import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'
import MmRating from 'components/MmRating'

const MMScorePopup = ({ scoreInfo }) => {
  const { t } = useTranslation('map')
  const { goBack } = useHistory()
  return (
    <Popup>
      <div className='popup__title'>
        <div>MM Score</div>
      </div>
      <div className='popup__score'>
        {scoreInfo?.description && <p dangerouslySetInnerHTML={{ __html: scoreInfo.description }} />}
        {scoreInfo?.scores && <div className='popup__score__list'>
          {Object.entries(scoreInfo.scores).map(([number, desc]) => <div
            key={number}
            className='popup__score__list__item'>
            <MmRating number={number} />
            {desc.join(', ')}
          </div>)}
        </div>}
        <ArrowBtn
          enlarged
          showArrow={false}
          text={t('IUnderstand')}
          action={goBack} />
      </div>
    </Popup>
  )
}

export default MMScorePopup